// eslint-disable-next-line import/no-unresolved
import keenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

if (!customElements.get('image-grid')) {
  customElements.define(
    'image-grid',
    class ImageGrid extends window.BAO.CustomElement {
      connectedCallback () {
        super.connectedCallback()

        this.isTicking = false
        this.lastKnownY = window.scrollY

        this.requestTick = this.requestTick.bind(this)
        this.updateEl = this.updateEl.bind(this)
        this.initialiseCarousel = this.initialiseCarousel.bind(this)

        this.updateEl()
      }

      setupListeners () {
        super.setupListeners()

        this.onScroll = this.onScroll.bind(this)

        window.addEventListener('scroll', this.onScroll, { passive: true })

        this.initialiseCarousel()
      }

      onScroll () {
        this.lastKnownY = window.scrollY

        this.requestTick()
      }

      requestTick () {
        if (!this.isTicking) requestAnimationFrame(this.updateEl)

        this.isTicking = true
      }

      updateEl () {
        this.isTicking = false

        this.animateElements()
      }

      animateElements () {
        const containerOffsetTop = getOffsetTop(this)
        const animationOffset = 0.86
        const elementStartPoint =
          containerOffsetTop - window.innerHeight * animationOffset

        const totalScrollAmount = this.lastKnownY - elementStartPoint

        this.els.image?.elements.forEach(el => {
          const productCentre =
            getOffsetTop(el) - containerOffsetTop + el.offsetHeight / 2
          el.setAttribute('aria-hidden', productCentre > totalScrollAmount)
          el.dataset.offset = productCentre
        })
      }

      initialiseCarousel () {
        if (window.innerWidth > 768) return

        const slidesEl = this.els.slides?.element
        const slideEls = slidesEl.querySelectorAll(
          '[data-image-grid-el="slide"]'
        )

        // eslint-disable-next-line new-cap
        new keenSlider(slidesEl, {
          slides: slideEls,
          slidesPerView: 1.2,
          spacing: 15,
          rubberband: false
        })
      }
    }
  )
}
